import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import LimitedFunctionalityList from '../LimitedFunctionalityList'
import {DateFormat} from '../../../../date_format'
import {purchaseStep} from '../../constants'
import PurchaseSuccessContent from '../purchaseLightBox/successStep/PurchaseSuccessContent'

export default class SwitchToFreeLightBoxContent extends TemplateView {
    constructor() {
        super()

        this.state = {
            purchaseStep: '',

            maxFreeUsers: 0,
            startDate: '',
            currentUsedUser: 0,
            unavailableInFreeFeatures: [],
            documentsBaseUrl: '',
            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
            },
            hostingZone: '',
            isHostingZoneChanged: false,
            context: '',
            isContextChanged: false,
        }

        this.onStatePropertyChanged('purchaseStep', (step) => {
            this.$switchToFree.toggle(step === purchaseStep.SWITCH_TO_FREE)
            this.$success.toggle(step === purchaseStep.SUCCESS)
        })

        this.onStatePropertyChanged('maxFreeUsers', (maxFreeUsers) => {
            this.$activeUsersHeader.text(messageResource.getMessage('licenses.switch_to_free.active_users_count', [maxFreeUsers]))
        })

        this.onAnyStatePropertyChanged(['maxFreeUsers', 'currentUsedUser', 'startDate'], () => {
            if (this.state.currentUsedUser > this.state.maxFreeUsers) {
                this.$activeUsersNote.text(messageResource.getMessage('licenses.switch_to_free.active_users_count_note', [
                        this.state.currentUsedUser - this.state.maxFreeUsers,
                        this.state.currentUsedUser,
                        this.dateFormatter.formatDate(this.state.startDate)
                    ])
                )
            }
        })

        this.onStatePropertyChanged('unavailableInFreeFeatures', (unavailableInFreeFeatures) => {
            this.limitedFunctionalityList.setState({unavailableInFreeFeatures})
            this.$limitedFunctionalityContainer.toggle(unavailableInFreeFeatures.length > 0)
        })

        this.onStatePropertyChanged('startDate', () => {
            this.successContent.setState({
                effectTitleText: messageResource.getMessage('licenses.switch_to_free.success_effect_title',
                    [this.dateFormatter.formatDate(this.state.startDate)])
            })
        })

        this.onAnyStatePropertyChanged(['documentsBaseUrl', 'documentUrls'], () => {
            const hasDocuments = !!this.state.documentUrls.serviceAgreementUrl
                                 || !!this.state.documentUrls.dataProcessingAgreementUrl
                                 || !!this.state.documentUrls.serviceAgreementExhibitUrl
            this.successContent.setState({
                documentsBaseUrl: this.state.documentsBaseUrl,
                documentUrls: this.state.documentUrls,
                documentsNoteText: hasDocuments ? messageResource.getMessage('licenses.purchase.success.additional_purchase_title') : ''
            })
        })

        this.onAnyStatePropertyChanged(['hostingZone', 'context', 'isHostingZoneChanged', 'isContextChanged'], () => {
            this.successContent.setState({
                hostingZone: this.state.hostingZone,
                context: this.state.context,
                isHostingZoneChanged: this.state.isHostingZoneChanged,
                isContextChanged: this.state.isContextChanged,
            })
        })
    }

    templateHtml() {
        return '<div class="content">' +
               '    <div class="switchToFree">' +
               '        <div class="imageContainer"/>' +
               '        <div class="activeUsersContainer">' +
               '            <div class="header"/>' +
               '            <div class="note"/>' +
               '        </div>' +
               '        <div class="limitedFunctionalityContainer"/>' +
               '    </div>' +
               '    <div class="success"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            limitedFunctionalityHeader: 'licenses.chooser.limited_functionality.list_title',
        }
    }

    afterRender() {
        this.$switchToFree = this.find('.switchToFree')
        this.$success = this.find('.success')

        this.$activeUsersHeader = this.find('.activeUsersContainer .header')
        this.$activeUsersNote = this.find('.activeUsersContainer .note')

        this.$limitedFunctionalityContainer = this.find('.limitedFunctionalityContainer')
        this.limitedFunctionalityList = new LimitedFunctionalityList().init(this.$limitedFunctionalityContainer)
        this.dateFormatter = new DateFormat('MMM dd, yyyy')

        this.successContent = new PurchaseSuccessContent().init(this.$success)
        this.successContent.setState({
            titleText: messageResource.getMessage('licenses.switch_to_free.success_title'),
            documentsNoteText: messageResource.getMessage('licenses.purchase.success.additional_purchase_title'),
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/switchToFreeLightBox/SwitchToFreeLightBoxContent.js